import "./ExteriorImg.css";
import { useHrStyles } from "../../Context/HRContext";
import { Button } from "react-bootstrap";

export default function ExteriorImg() {
  const hrStyles = useHrStyles();

  return (
    <div className="exterior-img-content">
      <h1 className="Ext-heading">Exterior Architecture</h1>
      <p className="Ext-text">
        Your building's exterior is its first impression, and we ensure it’s a
        lasting one. Our exterior architecture services focus on creating
        facades that not only look stunning but also respond to the building’s
        environment and purpose. We blend architectural style with practical
        solutions, ensuring your building is not only visually striking but also
        energy-efficient, sustainable, and resilient to the elements. Whether
        it's a modern, sleek design or a traditional aesthetic, we bring your
        vision to life with an eye for detail and harmony.
      </p>
      <Button
        href="/Contact"
        variant="warning"
        size="lg"
        className="centered-button"
      >
        Contact Us
      </Button>
      <hr style={hrStyles} />
    </div>
  );
}
